import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shu",
  "use": "icon-shu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shu\">\r\n    <path d=\"M512 85.333333c23.573333 0 42.666667 20.117333 42.666667 44.906667v763.52C554.666667 918.549333 535.573333 938.666667 512 938.666667s-42.666667-20.117333-42.666667-44.906667V130.24C469.333333 105.450667 488.426667 85.333333 512 85.333333z\" p-id=\"4332\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol